

// import React, { useEffect, useState } from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { Container, Spinner } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { FaArrowRight } from "react-icons/fa";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import mainlogo from "../Images/vantaralogo.png";

// const SliderHome = () => {
//   const [banners, setBanners] = useState([]);
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [loading, setLoading] = useState(true); 
//   const [imageLoaded, setImageLoaded] = useState({});
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchBanners = async () => {
//       try {
//         const res = await axios.get(
//           "https://vantara.datacubeglobal.com/api/get-banners"
//         );
//         if (res.data?.length) {
//           const sortedBanners = res.data.sort(
//             (a, b) => a.sort_order - b.sort_order
//           );
//           setBanners(sortedBanners);
//         }
//       } catch (err) {
//         console.error("Error fetching banners:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchBanners();
//   }, []);

//   const handleBannerClick = (banner) => {
//     if (banner?.reference_type && banner?.reference_id) {
//       navigate(`/shop/${banner.reference_type}/${banner.reference_id}`);
//     }
//   };

//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 600,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     arrows: false,
//     fade: true,
//     beforeChange: (current, next) => setActiveIndex(next),
//     customPaging: () => <div className="custom-dot" />,
//     appendDots: (dots) => (
//       <div
//         style={{
//           padding: "10px",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           marginBottom: 40,
//         }}
//       >
//         <ul
//           style={{
//             margin: 0,
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//         >
//           {dots}
//         </ul>
//       </div>
//     ),
//   };

//  if (loading) {
//   return (
//     <div
//       className="d-flex justify-content-center align-items-center bg-white"
//       style={{ height: "100vh", width: "100%" }}
//     >
//       {/* 🟣 Replace with your logo */}
//       <img
//        src={mainlogo}
//         alt="Loading..."
//         style={{
//           width: "180px",
//           height: "auto",
//           animation: "fade 1.5s ease-in-out infinite",
//         }}
//       />
//       <style>{`
//         @keyframes fade {
//           0% { opacity: 0.6; }
//           50% { opacity: 1; }
//           100% { opacity: 0.6; }
//         }
//       `}</style>
//     </div>
//   );
// }
// const getPresetPositionStyle = (preset, x, y) => {
//     if (preset === "preset") {
//       return { left: `${x}%`, top: `${y}%`, transform: "translate(-50%, -50%)" };
//     }

//     switch (preset) {
//       case "left":
//         return { left: "10%", top: "50%", transform: "translateY(-50%)" };
//       case "center":
//         return { left: "50%", top: "50%", transform: "translate(-50%, -50%)" };
//       case "right":
//         return { right: "10%", top: "50%", transform: "translateY(-50%)" };
//       case "top":
//         return { top: "15%", left: "50%", transform: "translateX(-50%)" };
//       case "bottom":
//         return { bottom: "15%", left: "50%", transform: "translateX(-50%)" };
//       default:
//         return { left: "50%", top: "50%", transform: "translate(-50%, -50%)" };
//     }
//   };


//   return (
//     <div className="position-relative custom-slider">
//       <Slider {...settings}>
//         {banners.map((banner) => {
//           const imgUrl = `https://vantara.datacubeglobal.com/storage/BannerImage/${banner.image_path}`;
//           const isLoaded = imageLoaded[banner.banner_id];

//           return (
//             <div key={banner.banner_id} className="slider-item">
//               <div
//                 className="d-flex align-items-center justify-content-center position-relative"
//                 style={{
//                   height: "calc(120vh - 100px)",
//                   width: "100%",
//                   backgroundColor: "#f0f0f0",
//                 }}
//               >
//                 {/* Loader while image loads */}
//                 {!isLoaded && (
//                   <div className="position-absolute d-flex justify-content-center align-items-center w-100 h-100">
//      <img
//        src={mainlogo}
//         alt="Loading..."
//         style={{
//           width: "180px",
//           height: "auto",
//           animation: "fade 1.5s ease-in-out infinite",
//         }}
//       />
//       <style>{`
//         @keyframes fade {
//           0% { opacity: 0.6; }
//           50% { opacity: 1; }
//           100% { opacity: 0.6; }
//         }
//       `}</style>
//   </div>
//                 )}

//                 {/* Actual image */}
//                 <img
//                   src={imgUrl}
//                   alt={banner.title}
//                   onLoad={() =>
//                     setImageLoaded((prev) => ({
//                       ...prev,
//                       [banner.banner_id]: true,
//                     }))
//                   }
//                   style={{
//                     opacity: isLoaded ? 1 : 0,
//                     transition: "opacity 0.8s ease-in-out",
//                     width: "100%",
//                     height: "100%",
//                     objectFit: "cover",
//                     position: "absolute",
//                     top: 0,
//                     left: 0,
//                   }}
//                 />

//                 {/* SOLUTION 1: Semi-transparent Overlay */}
//                 <div 
//                   className="position-absolute w-100 h-100"
//                   style={{
//                     background: 'linear-gradient(135deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.1) 100%)',
//                     top: 0,
//                     left: 0,
//                     zIndex: 1
//                   }}
//                 />

//                 {/* Banner Content */}
//                 {isLoaded && (
//                   <Container className="position-relative text-white text-left" style={{ zIndex: 2 }}>
//                     <p
//                       className="fs-2 mb-4 "
//                       style={{

//                         lineHeight: 1.2,

//                       }}
//                     >
//                       {banner.title}
//                     </p>

//                     <button
//                       className="btn btn-lg rounded-pill px-5 py-3 fw-semibold fs-6 d-inline-flex align-items-center gap-2"
//                       onClick={() => handleBannerClick(banner)}
//                       style={{
//                         pointerEvents: "auto",
//                         backgroundColor: "#7c0046",
//                         color: "white",
//                         border: '2px ',
//                         textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
//                       }}
//                     >
//                       Shop Now <FaArrowRight color="white" />
//                     </button>
//                   </Container>
//                 )}
//               </div>
//             </div>
//           );
//         })}
//       </Slider>

//       {/* Custom Styles */}
//           <style>{`
//         .slick-dots li div {
//           width: 16px !important;
//           height: 16px !important;
//           border-radius: 50%;
//           box-sizing: border-box;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background: transparent !important;
//           border: 1px solid transparent;  
//         }

//         .slick-dots li div::after {
//           content: "";
//           width: 8px;
//           height: 8px;
//           border-radius: 50%;
//           background: transparent;         
//           border: 1px solid black;         
//           display: block;
//         }

//         .slick-dots li.slick-active div {
//           border: 1px solid black;          
//         }

//         .slick-dots li.slick-active div::after {
//           background: black;                
//           border: none;                     
//         }

// @media (max-width: 768px) {
//            .custom-slider .slider-item > div {
//              height: 55vh !important;
//            }
//            .custom-slider p {
//             font-size: 1.5rem !important;  
//             margin-top: 40px;          
//           }
//           .custom-slider button {
//             padding: 10px 20px !important;
//              font-size: 0.9rem !important;
//            }
//          }
//        `}</style>
//     </div>
//   );
// };

// export default SliderHome;


// import React, { useEffect, useState } from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { Container } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { FaArrowRight } from "react-icons/fa";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import mainlogo from "../Images/vantaralogo.png";

// const SliderHome = () => {
//   const [banners, setBanners] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [imageLoaded, setImageLoaded] = useState({});
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchBanners = async () => {
//       try {
//         const res = await axios.get("https://vantara.datacubeglobal.com/api/get-banners");
//         if (res.data?.length) {
//           const sorted = res.data.sort((a, b) => a.sort_order - b.sort_order);
//           setBanners(sorted);
//         }
//       } catch (err) {
//         console.error("Error fetching banners:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchBanners();
//   }, []);

//   const handleBannerClick = (banner) => {
//     if (banner?.reference_type && banner?.reference_id) {
//       navigate(`/shop/${banner.reference_type}/${banner.reference_id}`);
//     } else if (banner?.button_link) {
//       window.location.href = banner.button_link;
//     }
//   };

//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 700,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     fade: true,
//     arrows: false,
//     beforeChange: (_, next) => setImageLoaded({ ...imageLoaded, active: next }),
//     customPaging: () => <div className="custom-dot" />,
//     appendDots: (dots) => (
//       <div
//         style={{
//           padding: "10px",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           marginBottom: 40,
//         }}
//       >
//         <ul
//           style={{
//             margin: 0,
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//         >
//           {dots}
//         </ul>
//       </div>
//     ),
//   };

//   const getPresetPositionStyle = (preset, x, y) => {
//     if (preset === "preset") {
//       return { left: `${x}%`, top: `${y}%`, transform: "translate(-50%, -50%)" };
//     }

//     switch (preset) {
//       case "left":
//         return { left: "10%", top: "50%", transform: "translateY(-50%)" };
//       case "center":
//         return { left: "50%", top: "50%", transform: "translate(-50%, -50%)" };
//       case "right":
//         return { right: "10%", top: "50%", transform: "translateY(-50%)" };
//       case "top":
//         return { top: "15%", left: "50%", transform: "translateX(-50%)" };
//       case "bottom":
//         return { bottom: "15%", left: "50%", transform: "translateX(-50%)" };
//       default:
//         return { left: "50%", top: "50%", transform: "translate(-50%, -50%)" };
//     }
//   };

//   if (loading) {
//     return (
//       <div
//         className="d-flex justify-content-center align-items-center bg-white"
//         style={{ height: "100vh", width: "100%" }}
//       >
//         <img
//           src={mainlogo}
//           alt="Loading..."
//           style={{
//             width: "180px",
//             height: "auto",
//             animation: "fade 1.5s ease-in-out infinite",
//           }}
//         />
//         <style>{`
//           @keyframes fade {
//             0% { opacity: 0.6; }
//             50% { opacity: 1; }
//             100% { opacity: 0.6; }
//           }
//         `}</style>
//       </div>
//     );
//   }

//   return (
//     <div className="position-relative custom-slider">
//       <Slider {...settings}>
//         {banners.map((banner) => {
//           const imgUrl = `https://vantara.datacubeglobal.com/storage/BannerImage/${banner.banner_image}`;
//           const isLoaded = imageLoaded[banner.banner_id];

//           return (
//             <div key={banner.banner_id} className="slider-item">
//               <div
//                 className="d-flex align-items-center justify-content-center position-relative"
//                 style={{
//                   height: "calc(120vh - 100px)",
//                   width: "100%",
//                   backgroundColor: "#f0f0f0",
//                 }}
//               >
//                 {/* Loader while image loads */}
//                 {!isLoaded && (
//                   <div className="position-absolute d-flex justify-content-center align-items-center w-100 h-100">
//                     <img
//                       src={mainlogo}
//                       alt="Loading..."
//                       style={{
//                         width: "180px",
//                         height: "auto",
//                         animation: "fade 1.5s ease-in-out infinite",
//                       }}
//                     />
//                   </div>
//                 )}

//                 {/* Background image */}
//                 <img
//                   src={imgUrl}
//                   alt={banner.banner_title}
//                   onLoad={() =>
//                     setImageLoaded((prev) => ({
//                       ...prev,
//                       [banner.banner_id]: true,
//                     }))
//                   }
//                   style={{
//                     opacity: isLoaded ? 1 : 0,
//                     transition: "opacity 0.8s ease-in-out",
//                     width: "100%",
//                     height: "100%",
//                     objectFit: "cover",
//                     position: "absolute",
//                     top: 0,
//                     left: 0,
//                   }}
//                 />

//                 {/* Overlay */}
//                 <div
//                   className="position-absolute w-100 h-100"
//                   style={{
//                     background:
//                       "linear-gradient(135deg, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0.1) 100%)",
//                     top: 0,
//                     left: 0,
//                     zIndex: 1,
//                   }}
//                 />

//                 {/* Dynamic Banner Text + Button */}
//                 {isLoaded && (
//                   <Container
//                     className="position-absolute"
//                     style={{
//                       ...getPresetPositionStyle(
//                         banner.preset_position,
//                         banner.button_x_position,
//                         banner.button_y_position
//                       ),
//                       zIndex: 2,
//                       color: "#fff",
//                       textAlign:
//                         banner.preset_position === "center" ? "center" : "left",
//                     }}
//                   >
//                     <h2
//                       className="fw-bold mb-3"
//                       style={{
//                         fontSize: "2.5rem",
//                         color: "#fff",
//                         textShadow: "2px 2px 6px rgba(0,0,0,0.6)",
//                       }}
//                     >
//                       {banner.banner_title}
//                     </h2>
//                     <p
//                       className="mb-4"
//                       style={{
//                         fontSize: "1.2rem",
//                         lineHeight: 1.6,
//                         maxWidth: "600px",
//                         color: "#f0f0f0",
//                         textShadow: "1px 1px 4px rgba(0,0,0,0.5)",
//                       }}
//                     >
//                       {banner.banner_subtitle}
//                     </p>

//                     {banner.button_text && (
//                       <button
//                         className="fw-semibold d-inline-flex align-items-center gap-2"
//                         onClick={() => handleBannerClick(banner)}
//                         style={{
//                           backgroundColor: banner.button_color || "#7c0046",
//                           color: banner.button_text_color || "#fff",
//                           fontSize: banner.button_font_size || "16px",
//                           border: "none",
//                           borderRadius:
//                             banner.button_shape === "pill"
//                               ? "50px"
//                               : banner.button_shape === "rounded"
//                               ? "10px"
//                               : "4px",
//                           padding: "12px 35px",
//                           boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
//                           transition: "all 0.3s ease",
//                         }}
//                         onMouseEnter={(e) => (e.target.style.opacity = "0.85")}
//                         onMouseLeave={(e) => (e.target.style.opacity = "1")}
//                       >
//                         {banner.button_text} <FaArrowRight />
//                       </button>
//                     )}
//                   </Container>
//                 )}
//               </div>
//             </div>
//           );
//         })}
//       </Slider>

//       {/* ⬇️ Keep your slick-dots code unchanged */}
//       <style>{`
//         .slick-dots li div {
//           width: 16px !important;
//           height: 16px !important;
//           border-radius: 50%;
//           box-sizing: border-box;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background: transparent !important;
//           border: 1px solid transparent;  
//         }

//         .slick-dots li div::after {
//           content: "";
//           width: 8px;
//           height: 8px;
//           border-radius: 50%;
//           background: transparent;         
//           border: 1px solid black;         
//           display: block;
//         }

//         .slick-dots li.slick-active div {
//           border: 1px solid black;          
//         }

//         .slick-dots li.slick-active div::after {
//           background: black;                
//           border: none;                     
//         }

//         @media (max-width: 768px) {
//           .custom-slider .slider-item > div {
//             height: 55vh !important;
//           }
//           .custom-slider p {
//             font-size: 1.5rem !important;  
//             margin-top: 40px;          
//           }
//           .custom-slider button {
//             padding: 10px 20px !important;
//             font-size: 0.9rem !important;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default SliderHome;

import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaArrowRight } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import mainlogo from "../Images/vantaralogo.png";

const SliderHome = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imageLoaded, setImageLoaded] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const res = await axios.get("https://vantara.datacubeglobal.com/api/get-banners");
        if (res.data?.length) {
          const sorted = res.data.sort((a, b) => a.sort_order - b.sort_order);
          setBanners(sorted);
        }
      } catch (err) {
        console.error("Error fetching banners:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchBanners();
  }, []);

  const handleBannerClick = (banner) => {
    if (banner?.reference_type && banner?.reference_id) {
      navigate(`/shop/${banner.reference_type}/${banner.reference_id}`);
    } else if (banner?.button_link) {
      window.location.href = banner.button_link;
    }
  };


  const getPresetPositionStyle = (preset_position, x, y) => {
    const pos = preset_position?.toLowerCase?.() || "center";

    if (pos === "preset_position") {
      return { left: `${x}%`, top: `${y}%`, transform: "translate(-50%, -50%)" };
    }

    switch (pos) {
      case "left":
        return { left: "10%", top: "50%", transform: "translateY(-50%)" };
      case "right":
        return { right: "10%", top: "50%", transform: "translateY(-50%)" };
      case "center":
        return { left: "50%", top: "50%", transform: "translate(-50%, -50%)" };
      case "top-left":
        return { top: "15%", left: "10%", transform: "none" };
      case "top-right":
        return { top: "15%", right: "10%", transform: "none" };
      case "bottom-left":
        return { bottom: "15%", left: "10%", transform: "none" };
      case "bottom-right":
        return { bottom: "15%", right: "10%", transform: "none" };
      case "top-center":
        return { top: "15%", left: "50%", transform: "translateX(-50%)" };
      case "bottom-center":
        return { bottom: "15%", left: "50%", transform: "translateX(-50%)" };
      default:
        return { left: "50%", top: "50%", transform: "translate(-50%, -50%)" };
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    fade: true,
    arrows: false,
    beforeChange: (_, next) => setImageLoaded({ ...imageLoaded, active: next }),
    customPaging: () => <div className="custom-dot" />,
    appendDots: (dots) => (
      <div
        style={{
          padding: "10px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 40,
        }}
      >
        <ul
          style={{
            margin: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {dots}
        </ul>
      </div>
    ),
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center bg-white"
        style={{ height: "100vh", width: "100%" }}
      >
        <img
          src={mainlogo}
          alt="Loading..."
          style={{
            width: "180px",
            height: "auto",
            animation: "fade 1.5s ease-in-out infinite",
          }}
        />
        <style>{`
          @keyframes fade {
            0% { opacity: 0.6; }
            50% { opacity: 1; }
            100% { opacity: 0.6; }
          }
        `}</style>
      </div>
    );
  }

  return (
    <div className="position-relative custom-slider">
      <Slider {...settings}>
        {banners.map((banner) => {
          const imgUrl = `https://vantara.datacubeglobal.com/storage/BannerImage/${banner.banner_image}`;
          const isLoaded = imageLoaded[banner.banner_id];

          return (
            <div key={banner.banner_id} className="slider-item">
              <div
                className="d-flex align-items-center justify-content-center position-relative"
                style={{
                  height: "calc(120vh - 100px)",
                  width: "100%",
                  backgroundColor: "#f0f0f0",
                }}
              >

                {!isLoaded && (
                  <div className="position-absolute d-flex justify-content-center align-items-center w-100 h-100">
                    <img
                      src={mainlogo}
                      alt="Loading..."
                      style={{
                        width: "180px",
                        height: "auto",
                        animation: "fade 1.5s ease-in-out infinite",
                      }}
                    />
                  </div>
                )}

                <img
                  src={imgUrl}
                  alt={banner.banner_title}
                  onLoad={() =>
                    setImageLoaded((prev) => ({
                      ...prev,
                      [banner.banner_id]: true,
                    }))
                  }
                  style={{
                    opacity: isLoaded ? 1 : 0,
                    transition: "opacity 0.8s ease-in-out",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    position: "absolute",
                    top: 0,
                    left: 0,
                  }}
                />


                <div
                  className="position-absolute w-100 h-100"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0.1) 100%)",
                    top: 0,
                    left: 0,
                    zIndex: 1,
                  }}
                />


                {isLoaded && (
                  <Container
                    className="position-absolute"
                    style={{
                      ...getPresetPositionStyle(
                        banner.preset_position,
                        banner.button_x_position,
                        banner.button_y_position
                      ),
                      width: "auto",
                      zIndex: 2,
                      color: "#fff",
                      textAlign:
                        banner.preset_position === "center"
                          ? "center"
                          : "left",
                    }}
                  >
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        fontSize: "2.5rem",
                        color: "#fff",
                        textShadow: "2px 2px 6px rgba(0,0,0,0.6)",
                      }}
                    >

                      {banner.banner_title?.replace(/\n/g, ' ').replace(/\s+/g, ' ')}
                    </h2>
                    <p
                      className="mb-4"
                      style={{
                        fontSize: "1.2rem",
                        lineHeight: 1.6,
                        maxWidth: "600px",
                        color: "#f0f0f0",
                        textShadow: "1px 1px 4px rgba(0,0,0,0.5)",
                      }}
                    >

                      {banner.banner_subtitle?.replace(/\n/g, ' ').replace(/\s+/g, ' ')}
                    </p>

                    {banner.button_text && (
                      <button
                        className="fw-semibold d-inline-flex align-items-center gap-2"
                        onClick={() => handleBannerClick(banner)}
                        style={{
                          backgroundColor: banner.button_color || "#7c0046",
                          color: banner.button_text_color || "#fff",
                          fontSize: banner.button_font_size || "16px",
                          border: "none",
                          borderRadius:
                            banner.button_shape === "pill"
                              ? "50px"
                              : banner.button_shape === "rounded"
                                ? "10px"
                                : "4px",
                          padding: "12px 35px",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
                          transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => (e.target.style.opacity = "0.85")}
                        onMouseLeave={(e) => (e.target.style.opacity = "1")}
                      >
                        {banner.button_text} <FaArrowRight />
                      </button>
                    )}
                  </Container>
                )}
              </div>
            </div>
          );
        })}
      </Slider>
      <style>{`
        .slick-dots li div {
          width: 16px !important;
          height: 16px !important;
          border-radius: 50%;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          background: transparent !important;
          border: 1px solid transparent;  
        }

        .slick-dots li div::after {
          content: "";
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: transparent;         
          border: 1px solid black;         
          display: block;
        }

        .slick-dots li.slick-active div {
          border: 1px solid black;          
        }

        .slick-dots li.slick-active div::after {
          background: black;                
          border: none;                     
        }

        @media (max-width: 768px) {
          .custom-slider .slider-item > div {
            height: 55vh !important;
          }
           .custom-slider p {
    font-size: 1.1rem !important;
    line-height: 1.4 !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 90vw;
  }

  .custom-slider button {
    padding: 8px 16px !important;
    font-size: 0.85rem !important;
  }
            
        }
      `}</style>
    </div>
  );
};

export default SliderHome;
